module.exports = __webpack_public_path__ + "img/m_mask_banner.74335a53.png";